/** @jsx jsx */
import React, { useContext, useState, useCallback } from 'react'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { rowHeaderRender, hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { jsx } from '@emotion/core'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { dateCol, numCol, strCol, intCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { Button, DatePicker, Input, message, Upload, Icon } from 'antd'
import { getSwitchBoardBNP, getAuthorization, getCredentials } from 'api/pgads'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'

import qs from 'querystring'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const BNP = ({ envConfig, actionPermits, apiTargetInfo }) => {
  const { authGodMode } = envConfig
  const [importResult, setImportReult] = useState([])

  const importPermisiion = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.SWITCHBOARD_IMPORT],
    matchAny: true,
  })

  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState([])
  const retrieve = ({ date = selectedDate }) => {
    setSpinning(true)
    getSwitchBoardBNP(apiTargetInfo)(date).fork(setError, data => {
      setData(data)
      setSpinning(false)
    })
  }

  const url = ft =>
    `${apiTargetInfo.baseUrl}/switchboard/import-bnp?${qs.stringify({
      fileType: ft,
    })}`
  const fileProps = {
    name: 'file',
    action: url('bnp'),
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const onFileUploadChange = useCallback(
    info => {
      if (info.file.status === 'done') {
        setSpinning(false)
        message.success(`${info.file.name} file uploaded successfully`)
        // setImportResponse(info.file.response)
        // message.info(info.file.response)
        setImportReult(info.file.response)
        // retrieveData()
      } else if (info.file.status === 'error') {
        setSpinning(false)
        // reportError(info.file.response)
        // onError(info)
        setError(info.file.response)
        if (info.file.response.appExceptionId !== 100)
          message.error(`${info.file.name} file have invalid data`)
      }
    },
    [setError, setSpinning]
  )

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <JcTmpErrorDialog
        visible={importResult.length > 0}
        errors={importResult}
        closeErrorPrompt={_ => setImportReult([])}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          BNP
        </Title>
        <DatePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            if (d && d.isValid) {
              setSelectedDate(d)
              retrieve({ date: d })
            }
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={_ => retrieve({ date: selectedDate })}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>

        <Filler />
        {importPermisiion && (
          <Upload
            {...fileProps}
            onChange={data => {
              setSpinning(true)
              onFileUploadChange(data)
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button>
              <Icon type="upload" /> Import
            </Button>
          </Upload>
        )}
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Grid
              fuzzyFilter={fuzzyFilter}
              sortOptions={[
                {
                  ident: 'transdate',
                  display: 'Transaction Date',
                  sortOrder: 'asc',
                },
                {
                  ident: 'unit',
                  display: 'Unit',
                  sortOrder: 'asc',
                },
                {
                  ident: 'transhour',
                  display: 'Transaction Hour',
                  isKey: true,
                  width: 150,
                  sortOrder: 'asc',
                },
              ]}
              sortEnabled={false}
              data={data}
              headers={IfSwbdBnpHeaders}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: false,
                rowHeaderRender,
                height: height - 50,
                width: width - 100,
                headerRowHeight: 30,
              })}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  apiTargetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(BNP)

const IfSwbdBnpHeaders = [
  dateCol({
    ident: 'transdate',
    display: 'Transaction Date',
    isKey: true,
    width: 150,
  }),
  intCol({
    ident: 'transhour',
    display: 'Transaction Hour',
    isKey: true,
    width: 150,
  }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true, width: 150 }),
  numCol({
    ident: 'unitGrossMwh',
    display: 'Unit Gross MWH',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'unitGrossMwhDiff',
    display: '(+) Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'unitAuxMwh',
    display: 'Unit Aux MWH',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'unitAuxMwhDiff',
    display: '(-) Diff',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'startupAuxMwh',
    display: 'StartUp Aux MWH',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'startupAuxMwhDiff',
    display: '(-) Diff',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'caswellBeachAuxMwh',
    display: 'Caswell Beach Aux MWH',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'caswellBeachAuxMwhDiff',
    display: '(-) Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'unit1TotalMwhHour',
    display: 'Unit1 Total MWH Net Hour',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'unit1TotalMwhDaily',
    display: 'Unit1 Total MWH Net Daily',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'unit2TotalMwhHour',
    display: 'Unit2 Total MWH Net Hour',
    isFiltered: true,
    width: 200,
  }),

  numCol({
    ident: 'unit2TotalMwhDaily',
    display: 'Unit2 Total MWH Net Daily',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'bnpTotalMwhHour',
    display: 'BNP Total MWH Net Hour',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'bnpTotalMwhDaily',
    display: 'BNP Total MWH Net Daily',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'mvarOut', display: 'MVR OUT', isFiltered: true }),
  numCol({ ident: 'mvarOutDiff', display: '(+) Diff', isFiltered: true }),
  numCol({ ident: 'mvarIn', display: 'MVR IN', isFiltered: true }),
  numCol({ ident: 'mvarInDiff', display: '(-) Diff', isFiltered: true }),
  numCol({ ident: 'total', display: 'Total', isFiltered: true }),

  modifierCol,
  modifiedDateCol,
].map(d => (d.type === 'num' ? { ...d, displayFormat: '0' } : d))
